import React from "react";
import Modal from "@components/atoms/Modal";
import OrderNowJewelryVariationScreen from "./OrderNowJewelryVariationScreen";
import { Diamond } from "@src/types/DiamondDetail";
import { useTranslation } from "react-i18next";

type OrderCartModalProps = {
  isOpen: boolean;
  onClose: () => void;
  mItem: Diamond;
  isBuyNow?: boolean;
};

const OrderCartModal = ({
  isOpen,
  onClose,
  mItem,
  isBuyNow = false,
}: OrderCartModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal
      headerTitle={
        isBuyNow
          ? t("orderNowModal.buyNow.title.text", "Buy Now")
          : t("orderNowModal.addToCart.title.text", "Add to Cart")
      }
      isOpen={isOpen}
      onClose={onClose}
      noPadding={true}
      size={560}
      enableToastMessage={true}
    >
      <OrderNowJewelryVariationScreen
        mItem={mItem}
        onClose={onClose}
        isBuyNow={isBuyNow}
      />
    </Modal>
  );
};

export default OrderCartModal;
